import './Sidebar.css';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../../context/AuthContext';

const Sidebar = ({ isOpen, onClose }) => {
    const { user, isAdmin } = useAuth();

    const adminMenuItems = [
        { path: '/dashboard', label: 'Dashboard' },
        { path: '/employees', label: 'Employees' },
        { path: '/attendance', label: 'Attendance' },
        { path: '/leaves', label: 'Leave Requests' },
        { path: '/tasks', label: 'Tasks' },
        { path: '/performance', label: 'Performance' },
        { path: '/standup-summary', label: 'Standup Summary' },
        { path: '/groups', label: 'Group Chat' },
        { path: '/calendar', label: 'Calendar' },
    ];

    const employeeMenuItems = [
        { path: '/dashboard', label: 'Dashboard' },
        { path: '/my-attendance', label: 'My Attendance' },
        { path: '/my-leaves', label: 'My Leaves' },
        { path: '/my-tasks', label: 'My Tasks' },
        { path: '/my-performance', label: 'My Performance' },
        { path: '/standup', label: 'Daily Standup' },
        { path: '/groups', label: 'Group Chat' },
        { path: '/calendar', label: 'Calendar' },
    ];

    const menuItems = isAdmin ? adminMenuItems : employeeMenuItems;

    return (
        <>
            {/* Mobile overlay backdrop */}
            {isOpen && (
                <div
                    className="sidebar-overlay"
                    onClick={onClose}
                    aria-label="Close sidebar"
                />
            )}

            <aside className={`sidebar${isOpen ? ' sidebar-open' : ''}`}>
                <div className="sidebar-header">
                    <NavLink to="/dashboard" className="logo-link" onClick={onClose}>
                        <motion.img
                            src="/genlab-logo.png"
                            alt="GenLab Logo"
                            className="logo-image"
                            animate={{
                                scale: [1, 1.1, 1],
                            }}
                            transition={{
                                duration: 3,
                                repeat: Infinity,
                                ease: "easeInOut"
                            }}
                            style={{ filter: 'drop-shadow(0 0 8px rgba(188, 240, 0, 0.3))' }}
                        />
                    </NavLink>
                    {/* Close button visible on mobile */}
                    <button
                        className="sidebar-close-btn"
                        onClick={onClose}
                        aria-label="Close sidebar"
                    >
                        ✕
                    </button>
                </div>

                <nav className="sidebar-nav">
                    {menuItems.map((item) => (
                        <NavLink
                            key={item.path}
                            to={item.path}
                            onClick={onClose}
                            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
                        >
                            <span className="sidebar-label">{item.label}</span>
                        </NavLink>
                    ))}
                </nav>

                <div className="sidebar-footer">
                    <div className="user-info">
                        <div className="user-avatar">
                            {user?.name?.charAt(0).toUpperCase()}
                        </div>
                        <div className="user-details">
                            <div className="user-name">{user?.name}</div>
                            <div className="user-role">
                                {user?.roles?.length > 0
                                    ? user.roles[0].split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')
                                    : user?.role?.charAt(0).toUpperCase() + user?.role?.slice(1)}
                            </div>
                        </div>
                    </div>
                </div>
            </aside>
        </>
    );
};

export default Sidebar;
